import {
  ptoMultiRateId,
  ptoMultiRateId as defaultPtoMultiRateId,
} from 'constants/MultiRateConstants';
import { MultiRateFormScheduleValues } from 'components/modals/FinancialInfoScheduleModal';
import { MultiRateFormValues } from 'components/modals/AssignmentDataModal/FinancialInfo';
import { AssignmentMultiRateViewModel, PayCodeModel } from 'api/adminApiClient';

const findPTOMultiRate = (
  multiRates: MultiRateFormScheduleValues[] | MultiRateFormValues[],
  ptoMultiRateId = defaultPtoMultiRateId,
) => {
  let ptoMultiRateIndex = -1;
  let ptoMultiRateObject = null;

  for (let i = 0; i < multiRates?.length; i++) {
    if (multiRates[i].payTypeId === ptoMultiRateId) {
      ptoMultiRateIndex = i;
      ptoMultiRateObject = multiRates[i];
      break;
    }
  }

  return { ptoMultiRateIndex, ptoMultiRateObject };
};

const getPTOMultiRateDetails = (
  payCodes?: PayCodeModel[],
  multiRates?: AssignmentMultiRateViewModel[],
): AssignmentMultiRateViewModel | undefined => {
  const matchingPayCode = payCodes?.find(
    (payCode) => payCode.payRateTypeId === ptoMultiRateId,
  );
  return multiRates?.find((m) => m.payCodeId === matchingPayCode?.id);
};

export { findPTOMultiRate, getPTOMultiRateDetails };
